import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Control.module.sass";
import cn from "classnames";
import Icon from "../../Icon";

const Control = ({ className, item }) => {
  const navigate = useNavigate();

  const getNextStep = () => {
    // Récupérer les données de progression entreprise et étudiant
    let progressData;
    let studentData;
    
    const potentialProgressPaths = [
      item?.progress?.entreprise,
      item?.progression?.entreprise,
      item?.entreprise,
    ];
    progressData = potentialProgressPaths.find(p => p);

    const potentialStudentPaths = [
      item?.progress?.etudiant,
      item?.progression?.etudiant,
      item?.etudiant,
    ];
    studentData = potentialStudentPaths.find(p => p);

    if (typeof item?.progress === 'string') {
      try {
        const parsed = JSON.parse(item.progress);
        progressData = parsed?.entreprise || progressData;
        studentData = parsed?.etudiant || studentData;
      } catch (e) {
        // Erreur de parsing, on ne fait rien
      }
    }

    if (typeof item?.progression === 'string') {
      try {
        const parsed = JSON.parse(item.progression);
        progressData = parsed?.entreprise || progressData;
        studentData = parsed?.etudiant || studentData;
      } catch (e) {
        // Erreur de parsing, on ne fait rien
      }
    }

    // Si on n'a pas trouvé dans progress/progression, chercher directement dans item.progression
    if (!progressData && item?.progression?.entreprise) {
      progressData = item.progression.entreprise;
    }
    if (!studentData && item?.progression?.etudiant) {
      studentData = item.progression.etudiant;
    }

    // Vérifier si l'étudiant a rempli ses informations
    const studentInfosFilled = studentData?.infos_remplies;

    // Si l'étudiant n'a pas rempli ses infos, pas d'accès aux étapes entreprise
    if (!studentInfosFilled) {
      return null; // Pas d'étape disponible
    }

    // Déterminer la prochaine étape en fonction de la progression entreprise
    if (!progressData) {
      // Aucune progression entreprise, commencer par l'étape 1
      return 1;
    }

    // Étape 1: Informations de base (infos_remplies) - CompanyCheckInformation1
    if (!progressData.infos_remplies) {
      return 1;
    }

    // Étape 2: Création du contrat (contrat_cree) - CompanyCheckInformation2
    if (progressData.infos_remplies && !progressData.contrat_cree) {
      return 2;
    }

    // Étape 3: Assignation des tuteurs (tuteur_assigne) - CompanyCheckInformation3
    if (progressData.infos_remplies && progressData.contrat_cree && !progressData.tuteur_assigne) {
      return 3;
    }

    // Étape 4: Validation du contrat
    if (progressData.infos_remplies && progressData.contrat_cree && progressData.tuteur_assigne && !progressData.valide) {
      return 4;
    }

    // Si tout est validé, aller au dashboard
    if (progressData.valide) {
      return 'dashboard';
    }

    // Par défaut, retourner à l'étape 1
    return 1;
  };

  const handleEdit = () => {
    const nextStep = getNextStep();
    
    // Si aucune étape disponible (en attente de l'étudiant), ne rien faire
    if (nextStep === null) {
      return;
    }
    
    if (nextStep === 'dashboard') {
      navigate(`/company/folder/${item.id}/view`);
    } else if (nextStep === 4) {
      // Étape 4: Validation du contrat (à implémenter)
      navigate(`/company/folder/${item.id}/validation`);
    } else {
      navigate(`/company/folder/${item.id}/${nextStep}`);
    }
  };

  const nextStep = getNextStep();
  const shouldHideButton = nextStep === null;

  if (shouldHideButton) {
    return null;
  }

  return (
    <div className={cn(styles.control, className)}>
      <button
        className={styles.button}
        onClick={handleEdit}
        aria-label="Modifier le dossier"
      >
        <Icon name="edit" size="20" />
      </button>
    </div>
  );
};

export default Control;